module.exports = __webpack_public_path__ + "img/icon-holidays.bb1a1b88.svg";